<template>
    <div>
        <div class="pb-5 sm:flex sm:items-center sm:justify-between mb-10">
            <h1 class="text-gray-800 text-3xl tracking-widest">
                {{  headline }}
            </h1>
            <div class="mt-3 flex sm:mt-0 sm:ml-4">
                <slot name="action"></slot>
                <!--<button type="button"
                        class="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                    Share
                </button>
                <button type="button"
                        class="ml-3 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                    Create
                </button>-->
            </div>
        </div>

        <slot></slot>

    </div>
</template>

<script>
export default {
    name: "Page",
    props: ['headline'],
}
</script>

<style scoped>

</style>